(() => {
  const hero = document.querySelector('.lus-editorial--hero');
  if (!hero) return;

  const announcement = document.querySelector('.announcement-bar-section');
  const header = document.querySelector('.section-header');
  const root = document.documentElement;

  const measure = () => {
    root.style.setProperty('--lus-home-announcement-height', `${announcement?.offsetHeight || 0}px`);
    root.style.setProperty('--lus-home-header-height', `${header?.offsetHeight || 0}px`);
  };
  const refresh = () => document.body.classList.toggle('lus-home-hero-passed', hero.getBoundingClientRect().bottom <= (header?.offsetHeight || 0));

  measure();
  refresh();
  addEventListener('scroll', refresh, { passive: true });
  addEventListener('resize', measure, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(announcement || hero);
})();
